/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-29.
 */
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { omit } from 'lodash';
import { apiUrl } from '../app.config';

const TOKEN_KEY = 'afs_token';

/**
 * Returns the token saved on local storage.
 */
export const getToken = () => localStorage.getItem(TOKEN_KEY);

/**
 * Saves the token into the local storage.
 * @param {string} token 
 */
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

/**
 * Removes the token from local storage.
 */
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

/**
 * Logs in the user.
 * @param {string} username 
 * @param {string} password 
 */
export const login = (username, password) => {
    return axios.post(`${apiUrl}auth`, {
        username,
        password
    }).then(response => {
        return Promise.resolve(response.data);
    });
};

/**
 * Logs out the user by removing the token.
 */
export const logout = () => { removeToken(); location.reload(); return false; };

/**
 * Created the authorization token header
 */
export const createAuthorizationTokenHeader = () => {
    const token = getToken();

    if (token) {
        return { Authorization: token };
    }
    return {};
};

/**
 * Reloads the page to get the new token
 */
export const onSuccess = () => location.reload();

/**
 * Validates if credentials are not null
 * @param {string} username 
 * @param {string} password 
 */
export const validCreedentials = (username, password) => {
    return username !== '' && password !== '';
};

/**
 * Returns info inside token, but ommiting exp and created props. 
 */
export const getCurrentUser = () => {
    const claims = jwtDecode(getToken());
    const cleanClaims = omit(claims, ['exp', 'created']);
    const permissions = cleanClaims.permissions || {};

    return {
        ...cleanClaims,
        permissions: JSON.parse(permissions)
    };
};



// WEBPACK FOOTER //
// ./security/index.js